// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__dtvvx","description":"MealItem_description__4w0xA","price":"MealItem_price__Y-fyE"};